import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button, Grid, Typography, TextField } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import CheckPermissions from '../../../authorization/authorization';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, companyShortName1, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import '../OrganizationManagement.scss';
import SearchIcon from '@mui/icons-material/Search';
export default function CircleManagementTable(props) {
    //#region 
    const [circlesToDataGrid, setCirclesToDataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltCircle, setDltCircle] = useState()
    const [tableCircles, setTableCircles] = useState([]);
    const Navigate = useNavigate();
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableCircles, tableDataLoaded]);

    useEffect(() => {
        const callAllCirclesAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);
            // const formdata = new FormData();
            // if (userOfficeCode == 10) {
            //     formdata.append("companyCode", '');
            // } else {
            //     formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
            // }
            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);
            // myHeaders.append("Content-Type", "application/json");

            // const raw = JSON.stringify({
            //     "officeCode": officeCode
            // });

            // const requestOptions = {
            //     method: "POST",
            //     body: formdata,
            //     headers: myHeaders,
            //     redirect: "follow"
            // };
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "companyCode": userOfficeCode == 10 ? userOfficeCode : parseInt(userOfficeCode.toString().slice(0, 2)),
                "pageNumber": 1,
                "pageSize": 9999
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            await fetch(cfpBaseUrl + "customerFaciliationPortal/getCirclesDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        setTableCircles(result.data);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                    } else {
                        setTableCircles([]);
                    }
                })
                .catch(() => {
                    setTableCircles([]);
                });
            setTableDataLoaded(true);
        }
        callAllCirclesAPI()
    }, [])

    const filterCircle = (circleCode) => {
        let itemFound = tableCircles.find(item => item.circleCode === circleCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        var formdata = new FormData();
        formdata.append("circleCode", dltCircle);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCircle", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableCircles]
                    let index = myArray.findIndex(obj => obj.circleCode == dltCircle);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableCircles(myArray)
                    }
                }
                else {
                }
            })
            .catch(() => {});
        handleClose2();
    }

    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'start', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Circle Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "created_by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "created_at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_by", headerName: 'Updator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_at", headerName: 'Updated', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "bank_name", headerName: 'Bank Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "erp_code", headerName: 'ERP Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "capital_code", headerName: 'Cap. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "security_code", headerName: 'Sec. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const item = filterCircle(params.id);
                    setDialogRowData(item);
                    setOpen(true);
                };
                const onDeleteCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltCircle(params.id)
                }
                const onEditCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const circleToEdit = filterCircle(params.id);
                    Navigate('/circle-management/update-circle', { state: { circleToEdit } })
                }
                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Read') ?
                                    <IconButton onClick={onViewCircle} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Update') ?
                                    <IconButton onClick={onEditCircle} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCircle}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            }
                        </Box>
                    </>
                )
            }
        }
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCircles
        const tempArray = []
        if (myArray) {
            //for(let i = 0; i <= myArray.length; i++){
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.circleCode ? item.circleCode : '-',
                    "completename": item.circleName ? item.circleName : '-',
                    "roles": item.roleName ? item.roleName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "bank_name": item.circleBankName ? item.circleBankName : '-',
                    "companyname": companyShortName(item.companyCode.toString()),
                    "erp_code": item.circleErpCode ? item.circleErpCode : '-',
                    "capital_code": item.circleCapitalCostAccountNo ? item.circleCapitalCostAccountNo : '-',
                    "security_code": item.circleSecurityAccountNo ? item.circleSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": ' ',
                "completename": ' ',
                "roles": ' ',
                "created_by": ' ',
                "created_at": ' ',
                "updated_by": ' ',
                "updated_at": ' ',

            }
            tempArray.push(dataGridObject)
        }
        setCirclesToDataGrid(tempArray);
        setFilteredData(tempArray);
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        if (!value) {
            setFilteredData(circlesToDataGrid);
            return;
        }

        const filtered = circlesToDataGrid.filter((row) =>
            row.id?.toString().toLowerCase().includes(value) ||
            row.completename?.toLowerCase().includes(value) ||
            row.companyname?.toLowerCase().includes(value) 
        );

        setFilteredData(filtered);
    };
    return (
        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2>
                        Circle Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Circle Management', 'Create') &&
                            < Link to="/circle-management/new-circle">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Circle
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <h3 className="page-title">Circle Management</h3>

                    <div
                        style={{
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "10px",
                            padding: "5px 10px",
                            border: "1px solid grey",
                            margin: "0px",
                        }}
                    >
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, Circle Name or Company Name"
                            maxLength={20}
                            style={{
                                flex: 1,
                                padding: "8px",
                                border: "none",
                                backgroundColor: "transparent",
                                outline: "none",
                                fontSize: "13px",
                                minWidth: "300px",
                            }}
                        />
                        <SearchIcon
                            sx={{
                                color: "#09669d",
                                width: 30,
                                height: 30,
                                borderRadius: "8px",
                                padding: "6px",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                "&:hover": {
                                    color: "#074f7d",
                                },
                            }}
                        />
                    </div>
                </Box>
                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        sx={tableStyle}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow;
                        }}
                    />
                </Box>
            </Box>

            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // fullWidth={true}
                // maxWidth={'sm'}
                PaperProps={{ sx: { width: '30%' } }}
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title">
                    <IconButton onClick={handleClose} sx={{ position: "relative", float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold' }}>Circle Details</Typography>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText id="alert-dialog-description">
                        <hr />
                        <Grid className='content-grid' sx={{ mt: '17px', display: 'flex', flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>ID:</h5><span>{dialogRowData.circleCode ? dialogRowData.circleCode : '-'}</span>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Name:</h5><p>{dialogRowData.circleName ? dialogRowData.circleName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Latitude:</h5><p>{dialogRowData.latitude ? dialogRowData.latitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Longitude:</h5><p>{dialogRowData.longitude ? dialogRowData.longitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>status:</h5><p>{(dialogRowData.status === '0' || dialogRowData.status === 'active') ? 'Active' : 'InActive'}</p>
                                </Box>


                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Store:</h5><p>{(dialogRowData.isStore === '1' || dialogRowData.isStore === 'Yes') ? 'Yes' : 'No'}</p>
                                </Box>






                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created by:</h5><p>{dialogRowData.createdBy ? dialogRowData.createdBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created at:</h5><p>{dialogRowData.createdDate ? convertDatewithTime(dialogRowData.createdDate) : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated By:</h5><p>{dialogRowData.updateBy ? dialogRowData.updateBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated At:</h5><p>{dialogRowData.updatedDate ? convertDatewithTime(dialogRowData.updatedDate) : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 1</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp1Name ? dialogRowData.cp1Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp1phone ? dialogRowData.cp1phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp1Mobile ? dialogRowData.cp1Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp1Email ? dialogRowData.cp1Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 2</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp2Name ? dialogRowData.cp2Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp2phone ? dialogRowData.cp2phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp2Mobile ? dialogRowData.cp2Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp2Email ? dialogRowData.cp2Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Bank Details</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Bank Name:</h5><p>{dialogRowData.circleBankName ? dialogRowData.circleBankName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >ERP Code:</h5><p>{dialogRowData.circleErpCode ? dialogRowData.circleErpCode : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Capital Cost Account No.:</h5><p>{dialogRowData.circleCapitalCostAccountNo ? dialogRowData.circleCapitalCostAccountNo : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Security Cost Account No.:</h5><p>{dialogRowData.circleSecurityAccountNo ? dialogRowData.circleSecurityAccountNo : '-'}</p>
                                </Box>
                            </Box>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog > */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: 3, maxWidth: 1000 } }}
                className="alert-popups"
            >
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    className="dialog-title"
                >
                    Circle Details
                    <IconButton onClick={handleClose} sx={{ color: 'black' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <DialogContentText sx={{ minHeight: 300 }}>
                        <Grid container spacing={1} sx={{ padding: '20px' }}>
                            {/* Section Header */}
                            <Grid item xs={12}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>General Information</h4>
                                </Box>
                            </Grid>

                            {/* Circle Info */}
                            {[
                                { label: 'ID', value: dialogRowData.circleCode },
                                { label: 'Name', value: dialogRowData.circleName },
                                { label: 'Latitude', value: dialogRowData.latitude },
                                { label: 'Longitude', value: dialogRowData.longitude },
                                {
                                    label: 'Status',
                                    value: dialogRowData.status === '0' || dialogRowData.status === 'active' ? 'Active' : 'Inactive',
                                },
                                {
                                    label: 'Store',
                                    value: dialogRowData.isStore === '1' || dialogRowData.isStore === 'Yes' ? 'Yes' : 'No',
                                },
                                { label: 'Created By', value: dialogRowData.createdBy },
                                {
                                    label: 'Created At',
                                    value: convertDatewithTime(dialogRowData.createdDate),
                                },
                                { label: 'Last Updated By', value: dialogRowData.updateBy },
                                {
                                    label: 'Last Updated At',
                                    value: convertDatewithTime(dialogRowData.updatedDate),
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 1 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 1</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp1Name },
                                { label: 'Phone', value: dialogRowData.cp1phone },
                                { label: 'Mobile', value: dialogRowData.cp1Mobile },
                                { label: 'Email', value: dialogRowData.cp1Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp1-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 2 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 2</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp2Name },
                                { label: 'Phone', value: dialogRowData.cp2phone },
                                { label: 'Mobile', value: dialogRowData.cp2Mobile },
                                { label: 'Email', value: dialogRowData.cp2Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp2-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Bank Details */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Bank Details</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Bank Name', value: dialogRowData.circleBankName },
                                { label: 'ERP Code', value: dialogRowData.circleErpCode },
                                { label: 'Capital Cost Account No.', value: dialogRowData.circleCapitalCostAccountNo },
                                { label: 'Security Cost Account No.', value: dialogRowData.circleSecurityAccountNo },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`bank-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}
